import React, { Component } from 'react';
import { func, number, oneOf } from 'prop-types';
import { connect } from 'react-redux';
import { Translate } from 'react-localize-redux';
import { withLang, langType } from '../../../../i18n';
import { updateVariableAction } from '../../../../actions';
import { relativeCategoryTypeValues, variableEditorType } from '../../../../constants/types';
import { LocalizedRichTextArea } from '../../../LocalizedInput';
import TabsContainer from '../../../TabsContainer';
import TabPane from '../../../TabPane';
import styles from './relativeVariableFeedback.module.css';
import editorStyles from '../../editor.module.css';
import { assignArrayItemInObject } from '../../../../util';

import belowAverageImg from '../../../../images/below_average.png';
import averageImg from '../../../../images/average.png';
import overAverageImg from '../../../../images/over_average.png';

const TRANSLATION_NAMESPACE = 'surveySchemaParts.dimensions.relativeFeedback';

export const categoryNameTranslationKey = (type) => {
  switch (type) {
    case relativeCategoryTypeValues[0]:
      return `${TRANSLATION_NAMESPACE}.belowAverage`;
    case relativeCategoryTypeValues[1]:
      return `${TRANSLATION_NAMESPACE}.average`;
    case relativeCategoryTypeValues[2]:
      return `${TRANSLATION_NAMESPACE}.overAverage`;
    default:
      return '';
  }
};

const CategoryImage = ({ type, translate }) => {
  const alt = translate(`${TRANSLATION_NAMESPACE}.previewImageAlt`);

  switch (type) {
    case relativeCategoryTypeValues[0]:
      return (
        <img
          className={styles.previewImage}
          src={belowAverageImg}
          alt={alt}
        />
      );
    case relativeCategoryTypeValues[1]:
      return (
        <img
          className={styles.previewImage}
          src={averageImg}
          alt={alt}
        />
      );
    case relativeCategoryTypeValues[2]:
      return (
        <img
          className={styles.previewImage}
          src={overAverageImg}
          alt={alt}
        />
      );
    default:
      return null;
  }
};
CategoryImage.propTypes = {
  type: oneOf(relativeCategoryTypeValues).isRequired,
  translate: func.isRequired
};

class RelativeVariableFeedback extends Component {
  constructor(props) {
    super(props);

    this.onLocalizedRTEChange = this.onLocalizedRTEChange.bind(this);
    this.updateResponseCategories = this.updateResponseCategories.bind(this);

    this.renderCategoryPaneContent = this.renderCategoryPaneContent.bind(this);
  }

  onLocalizedRTEChange(type) {
    return (lang, name) => (value) => {
      const changed = {
        [name]: { [lang]: value }
      };
      this.updateResponseCategories(type, changed);
    };
  }

  getCategoryIndexByType(type) {
    return this.props.variable.responseCategories.findIndex((responseCategory) =>
      responseCategory.relativeCategory.type === type);
  }

  updateResponseCategories(type, changed) {
    const { variable: { responseCategories: oldResponseCategories }, variableIndex } = this.props;
    const responseCategories = assignArrayItemInObject(oldResponseCategories,
      this.getCategoryIndexByType(type), changed);
    this.props.dispatchUpdateVariable(variableIndex, { responseCategories });
  }

  renderCategoryPaneContent(type) {
    const { variable, translate } = this.props;
    const categoryIndex = this.getCategoryIndexByType(type);
    const responseCategory = variable.responseCategories
      .find((rc) => rc.relativeCategory.type === type);
    return (
      <div>
        {categoryIndex === -1
          ? (
            <div className="messages error">
              <p><Translate id={`${TRANSLATION_NAMESPACE}.categoryError`} data={{ category: type }} /></p>
            </div>
          ) : null}
        <div className={`${editorStyles.contentContainer}`}>
          <div className={`${editorStyles.contentColumn} ${editorStyles.sideBar}`}>
            <h2 className={editorStyles.columnTitle}>
              <Translate id={`${TRANSLATION_NAMESPACE}.feedback`} />
            </h2>
            <CategoryImage type={type} translate={translate} />
            <LocalizedRichTextArea
              name="feedback"
              values={responseCategory.feedback}
              onInputChange={this.onLocalizedRTEChange(type)}
              placeholderTranslationNamespace="inLanguage"
            />
          </div>
          <div className={`${editorStyles.contentColumn} ${editorStyles.mainContent}`}>
            <h2 className={editorStyles.columnTitle}>
              <Translate id={`${TRANSLATION_NAMESPACE}.improvementSuggestion`} />
            </h2>
            <LocalizedRichTextArea
              name="improvementSuggestions"
              values={responseCategory.improvementSuggestions}
              onInputChange={this.onLocalizedRTEChange(type)}
              placeholderTranslationNamespace="inLanguage"
            />
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { translate: t } = this.props;
    return (
      <TabsContainer>
        {relativeCategoryTypeValues.map((type) => (
          <TabPane key={type} label={t(categoryNameTranslationKey(type))}>
            {this.renderCategoryPaneContent(type)}
          </TabPane>
        ))}
      </TabsContainer>
    );
  }
}

RelativeVariableFeedback.propTypes = {
  variableIndex: number.isRequired,
  variable: variableEditorType.isRequired,
  dispatchUpdateVariable: func.isRequired,
  ...langType
};

const mapDispatchToProps = (dispatch) => ({
  dispatchUpdateVariable: (index, variable) =>
    dispatch(updateVariableAction(index, variable))
});

export default withLang(connect(null, mapDispatchToProps)(RelativeVariableFeedback));
